module.exports = function getResource(label, vars = []) {
    const resources = { buyWith: 'Acheter avec' };

    return resources[label];
};
